import React from 'react'

import { CameraValidationTestResultsIProps } from '../hooks/useCameraValidationTest'
import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'

import { HStack, Text, VStack } from '@chakra-ui/react'

import { ResultBadge } from '@/components/ui'
import {
  MSEVideoPlayer,
  VALIDATION_VIDEO_PLAYER_HEIGHT,
  VALIDATION_VIDEO_PLAYER_WIDTH,
  VideoPlayer,
} from '@/features/video-player'

const successBadgeMessage = 'SUCCESSFUL'
const errorBadgeMessage = 'FAILED'

interface ValidateCameraStreamResultsIProps
  extends CameraValidationTestResultsIProps {
  deviceId?: string
}

export const ValidateCameraStreamResults = ({
  deviceId,
  ...testResults
}: ValidateCameraStreamResultsIProps) => {
  const isValid = testResults.url !== undefined
  const badgeMessage = isValid ? successBadgeMessage : errorBadgeMessage

  // Feature flag for MSE-based authenticated proxy streaming
  const isMSEStreamingEnabled = useFeatureFlag(
    FeatureFlag.authenticatedProxyStreaming
  )

  return (
    <VStack align='start' paddingBottom='6' paddingX='6' w='100%'>
      <HStack paddingTop='4'>
        <Text fontWeight='bold'>Status</Text>
        <ResultBadge isValid={isValid} message={badgeMessage} />
      </HStack>

      {isValid &&
        (isMSEStreamingEnabled && deviceId ? (
          <MSEVideoPlayer
            autoplay={true}
            cameraId={deviceId}
            placeholderHeight={VALIDATION_VIDEO_PLAYER_HEIGHT}
            placeholderWidth={VALIDATION_VIDEO_PLAYER_WIDTH}
            showControls={false}
          />
        ) : (
          <VideoPlayer
            autoplay={true}
            liveEnabled={true}
            liveOnly={true}
            pipActive={false}
            placeholderHeight={VALIDATION_VIDEO_PLAYER_HEIGHT}
            placeholderWidth={VALIDATION_VIDEO_PLAYER_WIDTH}
            showControls={false}
            showToggleLiveButton={false}
            url={testResults.url!}
          />
        ))}

      {!isValid && testResults.errorMessages !== undefined && (
        <>
          <Text fontWeight='bold' paddingTop='2'>
            Errors
          </Text>

          {/*Here's how we can display many errors at once if we need to */}
          {testResults.errorMessages.map((value, id) => (
            <Text key={id} paddingStart={2}>
              - {value}
            </Text>
          ))}
        </>
      )}
    </VStack>
  )
}
